export const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
export const phoneNumberRegex = /^\+48 \d{3} \d{3} \d{3}$/;
export const passwordRegex = /^(?=.*?[A-Z])(?=.*?[a-z])((?=.*?[0-9])|(?=.*?[#?!@$%^&*-])).{8,}$/
export const postalCode = /^[0-9]{2}-[0-9]{3}/